import moment from "moment";

export const filenameFromUrl = url => url.split("/").slice(-1)[0];
export const getLatestDate = datesArray =>
  moment
    .max(datesArray.flatMap(date => (date ? moment(date) : [])))
    .toDate()
    .toISOString();

export const formatTimestamp = timestamp => {
  const d = new Date(timestamp);
  // const [date, time] = timestamp.split("T");
  // const dateParts = date.split("-");
  // const timeParts = time.split(":");
  return `${d.toLocaleDateString()} ${d.toLocaleTimeString()}`;
};

export const convertNewLineToSpace = stringToConvert =>
  stringToConvert.replace(/\n/gi, " ");
